module.exports = __webpack_public_path__ + "static/media/ne.c885e8f2.svg";